<template>
  <div class="vw100 vh100 flex-box flex-col al-c ju-c">
    <div class="w100">
      <div class="w120 mc flex-box al-c">
        <div class="flex-1" style="height: 74px">
          <img class="logo" v-show="getConfig.logo" :src="getConfig.logo">
        </div>
        <!-- <el-button type="primary" plain round size="medium" @click="goHref()">游客登录</el-button> -->
      </div>
    </div>
    <div class="w100 mt10 login-wrapper flex-box ju-c" :style="{ 'background-image': `url(${baseUrl}images/login-bg.png)` }">
      <div class="flex-box al-c login-main" :style="{ 'background-image': `url(${baseUrl}images/login-main-bg.png)` }" >
        <div class="flex-1 pl20 pr20 ml20">
          <img :src="`${baseUrl}images/login-title1.png`">
        </div>
        <div class="login-view">
          <p class="pb10 tx-c" style="color: #666666; font-size:26px">办事大厅</p>
          <div class="w100 mt20 pl5 pr5">
            <el-input size="large" class="username-input" v-model="formInline.username" clearable @keyup.enter.native="handleSubmit" placeholder="用户名">
              <div slot="prefix" style="height:40px;width:40px;background-color:#218DEE">
                <i class="el-icon-user"></i>
              </div>
            </el-input>
          </div>
          <div class="w100 mt20 pl5 pr5">
            <el-input size="large" class="password-input" :type="passw" v-model="formInline.password" @keyup.enter.native="handleSubmit" clearable placeholder="密码">
              <div slot="prefix" style="height:40px;width:40px;background-color:#218DEE">
                <i class="el-icon-lock"></i>
              </div>
              <i slot="suffix" :class="iconString" @click="showPass" :style="{color:passw == 'password' ? '#C0C4CC' : '#2fb1e9'}" style="text-align: right"></i>
            </el-input>
          </div>
          <div class="w100 mt20 pl5 pr5 flex-box ju-sb" v-if="needCode">
            <el-input size="large" class="code-input" v-model="formInline.code" @keyup.enter.native="handleSubmit" placeholder="验证码">
            </el-input>
            <img class="code-img" :src="`/hallportal/code?randomStr=${formInline.randomStr}`" alt="验证码" title="点击切换验证码" @click="initCode">
          </div>
          <div class="w100 mt20 pl5 pr5 flex-box">
            <div class="flex-1">
              <el-checkbox v-model="remember" style="color:#9A9898">记住密码</el-checkbox>
            </div>
             <router-link class="cu-p" :to="'/forgetPassword'" style="color:#9A9898">忘记密码？</router-link>
            <router-link v-if="phoneBlo" class="cu-p" :to="'/phoneLogin'" style="color:#9A9898">手机登录</router-link>
          </div>
          <div class="w100 mt20 pb20 pl5 pr5">
            <el-button v-if="getConfig.logo_text=='南宁师范大学'" class="w100" size="large" type="primary" :disabled="logining" :loading="logining" @click="nsdSubmit" >登 录</el-button>
            <el-button v-else class="w100" size="large" type="primary" :disabled="logining" :loading="logining" @click="handleSubmit" >登 录</el-button>
          </div>
        </div>
      </div>
      <!-- <div v-else class="flex-box al-c ju-c login-main-btn"><el-button type="primary" plain round style="height:70px; width:200px;font-size:26px" @click="ssoLogin">登 录</el-button></div> -->
    </div>
    <!--<div class="w100 tx-c grey font-14" style="line-height:40px">技术支持：南宁市迈越软件有限公司</div>-->
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import {getDefaultPage, getLogoImg} from "@/api/admin/user";
import {userMissingMumber,getLoginConfig} from "@/api/login";
import AddRouterFunc from "@/router/addRouter";
import {generateCodeVerifier} from '@/util/utils';
import sso from '@/server/sso'
import routeData from '@/router/routerData'
import * as orignAxios from 'axios'
import request from '@/util/http'

export default {
  name: "Login",
  props: [],
  components: {},
  data() {
    return {
      baseUrl: process.env.BASE_URL,
      getConfig:{},
      loading: false,
      logining: false,
      // uesrName: "",
      // password: "",
      remember: false,
      needCode: false,
        iconString: 'el-icon-view',
        passw:"password",
      formInline: {
        username: "",
        password: "",
        code: "",
        randomStr: ""
      },
        phoneBlo: false
    };
  },
  computed: {
    ...mapGetters(["userToken", "accessToken", "userData"]),
  },
  created() {
    //清空缓存
    this.$store.commit("SET_ACCESS_TOKEN", null);
    this.$store.commit("SET_MENU", []);
    this.$store.commit("SET_PERMISSIONS", []);
    this.$store.commit("SET_CHOOSE_DEPT", []);
    // this.$store.commit("SET_ChOOSE_DATASCOPE_DEPT", []);
    this.$store.commit("SET_LOG_MSG", null);
    this.$store.commit("SET_ACTIVES", null);
    this.$store.commit("SET_ACTIVE_TAG", null);
    window.sessionStorage.setItem("nz_access_token", null);
    // sessionStorage.clear()
    // localStorage.clear();
    this.storageClear()

  },
  mounted() {
    this.getLoginConfig();
  },
  destroyed() {},
  methods: {
      showPass(){
          //点击图标是密码隐藏或显示
          if( this.passw=="text"){
              this.passw="password";
              //更换图标
              // this.iconString="el-icon-view";
          }else {
              this.passw="text";
              // this.iconString="el-icon-loading";
          };
      },
    ...mapActions(["setUserToken", "setUserData", "logout", "setAccessToken","bpmnSecurityLoginHandle"]),

    async handleSubmit(name) {
      if (this.needCode && !this.formInline.code) {
        this.$message.warning('请输入验证码')
        return;
      }
      if (!this.formInline.username || !this.formInline.password) {
        this.$message.warning('请输入登录账号和密码')
        return;
      }

      this.logining = true;
      let errorNum = await this.checkLoginError(this.formInline.username)
      if(errorNum >= 3 && !this.formInline.code){
        this.needCode = true
        this.initCode();
        this.$message.warning('请输入验证码')
        this.logining = false;
        return
      }
      if(errorNum<3){
        this.needCode = false;
        this.formInline.code = '';
      }
      // console.log(localStorage.getItem('userData'))
      //浏览器只允许一个账号登录
      // if(localStorage.getItem('userData')){
      //   this.$message.warning('该浏览器只能登录一个账号,请先退出上一账号后再试',3000)
      //   this.logining = false;
      //   return
      // }
      this.$store.dispatch("LoginByUsername", this.formInline).then(async res => {
        if ("access_token" in res.data) {
          // await this.bpmLogin(res.data.username)
          window.sessionStorage.setItem(
            "nz_access_token",
            "Bearer " + res.data.access_token
          );
          // 获取组织部门树
          this.$store.dispatch("getDeptTree").then(() => {
          }).catch((err) => {
            console.log(err)
          });
          this.bpmnSecurityLoginHandle({
            userName:res.data.username,
            deviceType:'pc'
          }).catch(() => {
            // this.$store.commit("SET_ACCESS_TOKEN", null);
            // sessionStorage.removeItem('nz_access_token')
          });
          //获取用户权限
          this.$store.dispatch("GetUserPermissions").then((res) => {
            //获取个人菜单;
            let userInfo = {
              deviceType: 'pc',
              userId: res.data.sysUser.userId,
              userImg: res.data.sysUser.avatar,
              userName: res.data.sysUser.username,
              deptId: res.data.sysUser.deptId,
              roleCodes: res.data.roleCodes,
              name:res.data.sysUser.name,
            };
            let routerData = res.data.permissions
            routerData = [
              ...routerData,
              '/office',
                '/test',
                '/statistical/all',
                '/ServeCenterDetail',
                '/notifyDetail',
                '/serveEvaluate',
                '/search',
                '/noticesAndFilesPagination',
                '/fileDetail',
                '/teacherTimetable',
                '/classRoomTimetable',
                '/MySchedule',
                '/classTimetable',
                '/staff',
                '/jobshire',
                '/annualappraisal',
                '/wage',
                '/classroomQuery',
                '/grade',
                '/teachingInquiry',
                '/evaluation',
            ]
            let newArr = JSON.parse(JSON.stringify(routerData))
              if((res.data.roleCodes||[]).includes('ROLE_ADMIN')){
              //   routerData = [];
              //   const routeHandler = function (arr) {

              //   for(let i=0;i<arr.length;i++){
              //     routerData.push(arr[i].path)
              //     if(arr[i].children){
              //       routeHandler(arr[i].children)
              //     }
              //   }
              // }
              //     routeHandler(newArr)
                  newArr = newArr.concat([
                "system-management",
                "business-management",
                "advices-management",
                "efficiency-management",
                "data-management",
              ])
            }
              routerData = [...newArr]
              this.setUserData({
              ...userInfo,
              routerData,
            });

            localStorage.setItem('userData', JSON.stringify({
              ...userInfo,
              routerData,
            }))

            sessionStorage.setItem('loginFrom', 'system')

            this.logining = false

            const routers = AddRouterFunc.getNewRouerData(
              routerData
            );
            this.$router.addRoutes(routers);

            this.$router.push('/');

          }).catch((err) => {
            console.log(err)
          })
        } else {
          this.logining = false;
        }
      }).catch((err) => {
        console.log(err)
        this.$message.error(err.msg)
        this.formInline.password = '';
        this.formInline.code = '';
        if(this.needCode){
          this.initCode();
        }
        this.logining = false;
      })
    },
    nsdSubmit(){
      if (!this.formInline.username || !this.formInline.password) {
        this.$message.warning('请输入登录账号和密码')
        return;
      }
      this.logining = true;
      orignAxios.post(
        '/my_sso/login.php',
        {username:this.formInline.username,password:this.formInline.password,grant_type:'password'},
        {baseURL:'/nsdApi'}
      ).then(({data}) => {
        if(data.code!=0){
          this.$message.error(data.msg||'登录出错')
          this.logining = false;
          return
        }
        sessionStorage.setItem('nsdBpmToken', data.data.access_token)
        this.$store.dispatch("LoginWithoutPwd", {username: this.formInline.username})
        .then(async res => {
          if ("access_token" in res.data) {
            window.sessionStorage.setItem(
              "nz_access_token",
              "Bearer " + res.data.access_token
            );
            // 获取组织部门树
            this.$store.dispatch("getDeptTree").then(() => {
            }).catch((err) => {
              console.log(err)
            });
            this.bpmnSecurityLoginHandle({
              userName:res.data.username,
              deviceType:'pc'
            }).catch(() => {
              // this.$store.commit("SET_ACCESS_TOKEN", null);
              // sessionStorage.removeItem('nz_access_token')
            });
            //获取用户权限
            this.$store.dispatch("GetUserPermissions").then((res) => {
              //获取个人菜单;
              let userInfo = {
                deviceType: 'pc',
                userId: res.data.sysUser.userId,
                userImg: res.data.sysUser.avatar,
                userName: res.data.sysUser.username,
                deptId: res.data.sysUser.deptId,
                roleCodes: res.data.roleCodes,
              };
              let routerData = res.data.permissions
              routerData = [
                ...routerData,
                '/office',
                '/test',
                '/statistical/all',
                '/ServeCenterDetail',
                '/notifyDetail',
                '/search',
                '/noticesAndFilesPagination',
                '/fileDetail'
              ]
              if((res.data.roleCodes||[]).includes('ROLE_ADMIN')){
                // routerData = [];
                // const routeHandler = function (arr) {
                //   for(let i=0;i<arr.length;i++){
                //     routerData.push(arr[i].path)
                //     if(arr[i].children){
                //       routeHandler(arr[i].children)
                //     }
                //   }
                // }
                // routeHandler(routeData)
                routerData = routerData.concat([
                  "system-management",
                  "business-management",
                  "advices-management",
                  "efficiency-management",
                  "data-management",
                ])
              }

              this.setUserData({
                ...userInfo,
                routerData,
              });

              localStorage.setItem('userData', JSON.stringify({
                ...userInfo,
                routerData,
              }))

              sessionStorage.setItem('loginFrom', 'system')

              this.logining = false

              const routers = AddRouterFunc.getNewRouerData(
                routerData
              );
              this.$router.addRoutes(routers);

              this.$router.push('/');

            }).catch((err) => {
              console.log(err)
            })
          } else {
            this.logining = false;
          }
        }).catch((err) => {
          console.log(err)
          this.$message.error(err.msg)
          this.formInline.password = '';
          this.formInline.code = '';
          if(this.needCode){
            this.initCode();
          }
          this.logining = false;
        })
      })
    },
    checkLoginError(username){
      return new Promise((resolve, reject) => {
        userMissingMumber({username}).then(({data}) => {
          if(data.code==0){
            resolve(data.data)
          }else {
            this.$message.error(data.msg)
            reject()
          }
        })
      })
    },
    bpmLogin(username){
      return new Promise((resolve, reject) => {
        this.bpmnSecurityLoginHandle({
          userName:username,
          deviceType:'pc'
        }).then(()=>{
          resolve()
        }).catch(() => {
          this.$store.commit("SET_ACCESS_TOKEN", null);
          sessionStorage.removeItem('nz_access_token')
          reject()
        })
      })
    },
    initCode(){
      this.formInline.randomStr = generateCodeVerifier(5);
    },
    storageClear(){
      localStorage.removeItem('userData')
      localStorage.removeItem('token')
      sessionStorage.removeItem('vuex')
      sessionStorage.removeItem('nz_access_token')
      sessionStorage.removeItem('setConfig')
      sessionStorage.removeItem('userData')
    },
    addRouter() {
      const routerData = AddRouterFunc.getNewRouerData(
        this.userData.routerData
      );
      // console.log(routerArr);
      this.$router.addRoutes(routerData);
    },
    async getLoginConfig() {
      let res = await getLoginConfig();
      res.data.data.isOpenCassso == "1"
        ? (res.data.data.isOpenCassso = true)
        : (res.data.data.isOpenCassso = false);
      res.data.data.middlePage == "1"
        ? (res.data.data.middlePage = true)
        : (res.data.data.middlePage = false);
      res.data.data.phone == "1"
        ? (res.data.data.phone = true)
        : (res.data.data.phone = false);
      res.data.data.mobileOrPc == "1"
        ? (res.data.data.mobileOrPc = true)
        : (res.data.data.mobileOrPc = false);
      this.phoneBlo = res.data.data.phone;
      this.getConfig = res.data.data;
      window.sessionStorage.setItem(
        "setConfig",
        JSON.stringify(this.getConfig)
      );
      let faviconLink = document.querySelector("#faviconLink");
      if (faviconLink) {
        faviconLink.setAttribute("href", this.getConfig.favicon);
      }
    },
  },
  watch: {},
  filters: {},
};
</script>

<style scoped lang="less">
.login-wrapper {
  height: 680px;
  background: #368ae2 center bottom no-repeat;
}

.login-main {
  margin-top: 60px;
  width: 900px;
  height: 430px;
  background: #fff right bottom no-repeat;
  box-shadow: 0 0 12px 10px #327cca;
}
.login-main-btn {
  margin-top: 60px;
  width: 900px;
  height: 430px;
}

.login-view {
  margin-right: 40px;
  width: 350px;
  padding: 20px 0 0 40px;
  border-left: 1px solid #ddd;
}
.username-input,.password-input {
  line-height: 40px;
  /deep/ .el-input__inner:not(.code-input) {
    border-radius: 0;
    text-indent: 20px;
    background-color: #F2F4F4;
  }
  /deep/ .el-input__prefix {
    left: 0;
    color: #fff;
    font-size: 18px;
  }
}
.code-input {
  width: 140px;
}
.code-img {
  height: 40px;
  width: 140px;
  cursor: pointer;
}
  .logo{
    height: 60px;
    margin-top: 10px;
  }
</style>
